"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeProvider: ()=>_context.ThemeProvider,
    AppTheme: ()=>_context.AppTheme,
    CustomIcon: ()=>_context.CustomIcon,
    NavigationItem: ()=>_context.NavigationItem,
    useTheme: ()=>_context.useTheme
});
const _context = require("./context");
